export function loadPersistedConfig(key, storage) {
  const rawState = storage.getItem(key)

  if (!rawState) {
    return {}
  }

  try {
    const persistedState = JSON.parse(rawState)
    const sanitizedState = persistedState?.config
      ? {config: persistedState.config}
      : {}

    storage.setItem(key, JSON.stringify(sanitizedState))

    return sanitizedState
  } catch (error) {
    storage.removeItem(key)
    return {}
  }
}
